import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {
  API_SERVER: string = environment.baseApiUrl;
  reloadTable$ = new BehaviorSubject(false);

  constructor(private httpClient: HttpClient) { }

  findAll(location_id): Observable<any> {
    return this.httpClient
      .get(`${this.API_SERVER}audit-trails/${location_id}`);
  }

  findByParams(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach(elem => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient.get(this.API_SERVER + 'audit-trails/findbyparams', { params: Params })
  }
}
